import axios from "axios";
import { webAPIUrl } from "./AppSetting";
import { toast } from "react-toastify";
import { useUser,logoutAxios } from "./hooks/useQueries";
import { userStore } from "./stores/userStore";
import { v4 as uuidv4 } from 'uuid';

const instance = axios.create({
  baseURL: webAPIUrl,
  withCredentials: true,
  // headers:{
  //      'Authorization': user != null ? `Basic ${user.token}` : ""
  // }
});

instance.interceptors.request.use(async (response) => {
   const user = JSON.parse(localStorage.getItem("user"));

  let sessionToken = localStorage.getItem("sessionToken");

  if(sessionToken == null || sessionToken.includes("None") || sessionToken.includes("_")){
     sessionToken = uuidv4();
     localStorage.setItem("sessionToken",sessionToken);
  }

  const token = user?.jwtToken ?? "";
  response.headers.Authorization = token;
  response.headers["X-Session-Token"] = `${sessionToken}`;

  return response;
});

instance.interceptors.response.use(
  
  (response) => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
 function (error) {
  //const {logout} = useUser();

    if (!error.response) {
      return Promise.reject(error);
    }

    const { status } = error.response;

    if (status === 401) {
      logoutAxios();
    }
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  }
);


export default instance;
